import { css, BaseThemedCssFunction } from 'styled-components';

type MediaType = {
  xxl: BaseThemedCssFunction<any>;
  xl: BaseThemedCssFunction<any>;
  lg: BaseThemedCssFunction<any>;
  md: BaseThemedCssFunction<any>;
  sm: BaseThemedCssFunction<any>;
  xs: BaseThemedCssFunction<any>;
};

// WARNING! please keep sync from /src/main.scss
// discuss with @urmauur if you want change breakpoint
const BreakPoints = {
  xxl: 1700,
  xl: 1440,
  lg: 1200,
  md: 992,
  sm: 768,
  xs: 576
};

const defaultValue = {
  xxl: undefined,
  xl: undefined,
  lg: undefined,
  md: undefined,
  sm: undefined,
  xs: undefined
};

// iterate through the sizes and create a media template
export const MinWidth: MediaType = Object.keys(BreakPoints).reduce(
  (accumulator: MediaType, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = BreakPoints[label] / 16;
    return {
      ...accumulator,
      [label]: (first, ...args) => css`
        @media (min-width: ${emSize}em) {
          ${css(first, ...args)};
        }
      `
    };
  },
  defaultValue
);

export const MaxWidth: MediaType = Object.keys(BreakPoints).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = BreakPoints[label] / 16;
  return {
    ...accumulator,
    [label]: (first, ...args) => css`
      @media (max-width: ${emSize}em) {
        ${css(first, ...args)};
      }
    `
  };
}, defaultValue);
